// Generated by Tool88TokenManagerExporter.cs from WayFinder TokenManager.
// Copy this file to: src/data/tool88TokenCatalog.generated.js
// Exported at UTC: 2026-05-14T01:27:37.6634268Z
// Unity scene: Assets/Scenes/xx1.unity

export const TOOL88_SHIPPED_TOKEN_REGISTRY = Object.freeze([
  {
    symbol: "ATH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xbe0ed4138121ecfc5c0e56b40517da27e6c5226b",
    sourceId: "b7b04a070578e8842bd9e8590e7b6d91:eth"
  },
  {
    symbol: "DAI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
    sourceId: "421cf1f36608d7144a754c411ffcab8e:eth"
  },
  {
    symbol: "DAI",
    decimals: 18,
    chainKey: "pulsechain",
    contractAddress: "0xefd766ccb38eaf1dfd701853bfce31359239f305",
    sourceId: "421cf1f36608d7144a754c411ffcab8e:pulsechain"
  },
  {
    symbol: "DOLORES",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xdc8241475b87d351e45608cd78474dbccab8adfc",
    sourceId: "8b80d66c6dcb5884baceff3bb66b9ba2:eth"
  },
  {
    symbol: "FLC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x102c776ddb30c754ded4fdcc77a19230a60d4e4f",
    sourceId: "9c15d7dbca9e0a34f97729454c400e23:eth"
  },
  {
    symbol: "INU",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xaaea9eff18263b7c9cf7312bbce4f892ece36c3e",
    sourceId: "8602b4b0e940f9744b50dec73dd8f177:eth"
  },
  {
    symbol: "INU",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "5jFnsfx36DyGk8uVGrbXnVUMTsBkPXGpx6e69BiGFzko",
    sourceId: "8602b4b0e940f9744b50dec73dd8f177:solana"
  },
  {
    symbol: "JASMY",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7420b4b9a0110cdc71fb720908340c03f9bc03ec",
    sourceId: "db9af1d1dab89ad4bb4ff46b400b3aad:eth"
  },
  {
    symbol: "MON",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc555d625828c4527d477e595ff1dd5801b4a600e",
    sourceId: "7fcc24b244366d94cb6f43fb6dcd69ec:eth"
  },
  {
    symbol: "PEIPEI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x3ffeea07a27fab7ad1df5297fa75e77a43cb5790",
    sourceId: "f6f1847d278256049a76ea4b979544a4:eth"
  },
  {
    symbol: "PNDC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x423f4e6138e475d85cf7ea071ac92097ed631eea",
    sourceId: "efa010345232ea84fa9892327ab37508:eth"
  },
  {
    symbol: "QUIL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8143182a775c54578c8b7b3ef77982498866945d",
    sourceId: "4ccff636d8866a445bebfa53514a18c2:eth"
  },
  {
    symbol: "SOL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xd31a59c85ae9d8edefec411d448f90841571b89c",
    sourceId: "5a97384423c26334ea7e69b6e9e6ca40:eth"
  },
  {
    symbol: "TAIKO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x10dea67478c5f8c5e2d90e5e9b26dbe60c54d800",
    sourceId: "83d117106b7f0c942b99d556e8d8134c:eth"
  },
  {
    symbol: "UBAYC",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x1e610de0d7acfa1d820024948a91d96c5c9ce6b9",
    sourceId: "34ddc75fa654c83439859c5ee9219542:eth"
  },
  {
    symbol: "USDC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    sourceId: "3b53a910043307c48a1940702972a892:eth"
  },
  {
    symbol: "USDC",
    decimals: 12,
    chainKey: "evm:43114",
    contractAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    sourceId: "3b53a910043307c48a1940702972a892:avax"
  },
  {
    symbol: "USDC",
    decimals: 12,
    chainKey: "solana",
    contractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    sourceId: "3b53a910043307c48a1940702972a892:solana"
  },
  {
    symbol: "USDT",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    sourceId: "f8c976c7bb43a34499b304e5970caa81:eth"
  },
  {
    symbol: "USDT",
    decimals: 6,
    chainKey: "tron",
    contractAddress: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
    sourceId: "f8c976c7bb43a34499b304e5970caa81:tron"
  },
  {
    symbol: "USDT",
    decimals: 6,
    chainKey: "ton",
    contractAddress: "0:b113a994b5024a16719f69139328eb759596c38a25f59028b146fecdc3621dfe",
    sourceId: "f8c976c7bb43a34499b304e5970caa81:ton"
  },
  {
    symbol: "USDT",
    decimals: 6,
    chainKey: "evm:43114",
    contractAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    sourceId: "f8c976c7bb43a34499b304e5970caa81:avax"
  },
  {
    symbol: "WETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    sourceId: "454707a38b9159e45bcfcfed46d0aebf:eth"
  },
  {
    symbol: "WETH",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "FeGn77dhg1KXRRFeSwwMiykZnZPw5JXW6naf2aQgZDQf",
    sourceId: "454707a38b9159e45bcfcfed46d0aebf:solana"
  },
  {
    symbol: "SAND",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
    sourceId: "145a3beadf6207847a908e80eaaea1ca:eth"
  },
  {
    symbol: "PYR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x430ef9263e76dae63c84292c3409d61c598e9682",
    sourceId: "9b24532e8642e2441b59ec2d68676935:eth"
  },
  {
    symbol: "UNI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    sourceId: "62312f01b96b49c4790199b4baf49cd3:eth"
  },
  {
    symbol: "GRT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
    sourceId: "1f8151c71fe8daa4ea787ec26e0193f0:eth"
  },
  {
    symbol: "MATIC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
    sourceId: "5bac2ba1ad0992a459307c5bf5e7c9ec:eth"
  },
  {
    symbol: "OCSETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x2401c39d7ba9e283668a53fcc7b8f5fd9e716fdf",
    sourceId: "295b02b34bffd7047be638c053905c85:eth"
  },
  {
    symbol: "SHIB",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    sourceId: "0297e6ac93d33354e8af18e4a0e5512a:eth"
  },
  {
    symbol: "ANKR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x72915a4bfa52a37490e6085f2f6fb06b548639231722ac65ba2703db7e9799e4",
    sourceId: "f69c5fd1ae573574daf26d51f2b3a6d5:eth"
  },
  {
    symbol: "AAVE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
    sourceId: "594fd00d8e1082d4798409a54a77ce06:eth"
  },
  {
    symbol: "BSC-USD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x55d398326f99059ff775485246999027b3197955",
    sourceId: "7ef54a46844d4134a993d1c78c49ebd4:eth"
  },
  {
    symbol: "GALA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8290333cef9e6d528dd5618fb97a76f268f3edd4",
    sourceId: "c488a83021a2a884390b4cb7531f093c:eth"
  },
  {
    symbol: "LINK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x514910771af9ca656af840dff83e8264ecf986ca",
    sourceId: "108b03b85655ff04cb54d79ff1274c50:eth"
  },
  {
    symbol: "OPTI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
    sourceId: "2d34c16133ef8a64ebe5374966a51df1:eth"
  },
  {
    symbol: "STETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
    sourceId: "19caead8a098e9d408c3903f3893da76:eth"
  },
  {
    symbol: "LON",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0000000000095413afc295d19edeb1ad7b71c952",
    sourceId: "77e7943600c7d404eba612bfe5bdb1b1:eth"
  },
  {
    symbol: "VERI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8f3470a7388c05ee4e7af3d01d8c722b0ff52374",
    sourceId: "d9e882155c89a064faa4b0ae4eba2adc:eth"
  },
  {
    symbol: "VERI",
    decimals: 18,
    chainKey: "pulsechain",
    contractAddress: "0x8f3470a7388c05ee4e7af3d01d8c722b0ff52374",
    sourceId: "d9e882155c89a064faa4b0ae4eba2adc:pulsechain"
  },
  {
    symbol: "TON",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
    sourceId: "a1ad963b935bb7a44acda5c18e90c456:eth"
  },
  {
    symbol: "RSTK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x12ef10a4fc6e1ea44b4ca9508760ff51c647bb71",
    sourceId: "16b1d13df31ff294cb6d42f89f91dd79:eth"
  },
  {
    symbol: "MUBI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x38e382f74dfb84608f3c1f10187f6bef5951de93",
    sourceId: "d7dec096b8843ad4f880bf0dd510708e:eth"
  },
  {
    symbol: "3CRV",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6c3f90f043a72fa612cbac8115ee7e52bde6e490",
    sourceId: "8cc38447d6c4f1b46b552b34e8338988:eth"
  },
  {
    symbol: "DEFROGS",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xd555498a524612c67f286df0e0a9a64a73a7cdc7",
    sourceId: "885cb08cecfeb7644bfc3e9363de03f4:eth"
  },
  {
    symbol: "INUS",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x39207d2e2feef178fbda8083914554c59d9f8c00",
    sourceId: "656af05ae00414740b554f2f14aea3b6:eth"
  },
  {
    symbol: "FTM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
    sourceId: "b5bd1a41e1c7a9847ae83a392f212be2:eth"
  },
  {
    symbol: "WFTM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
    sourceId: "108303e8d768c40479a7756870db38e5:eth"
  },
  {
    symbol: "XEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x06450dee7fd2fb8e39061434babcfc05599a6fb8",
    sourceId: "28c8afa60fb651845bfe40e413a41f4d:eth"
  },
  {
    symbol: "WAGMIGAMES",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x3b604747ad1720c01ded0455728b62c0d2f100f0",
    sourceId: "7e746a02da2f13242afe2c611d4ef26e:eth"
  },
  {
    symbol: "AUSDT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x23878914efe38d27c4d67ab83ed1b93a74d4086a",
    sourceId: "65cbb54fa06b7684aa9bb431d0843e8c:eth"
  },
  {
    symbol: "PEPE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
    sourceId: "0c9835b547fb3704a9156bc6985fa563:eth"
  },
  {
    symbol: "RNDR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
    sourceId: "cd747e2a73bf0e84ba90d00b82991fdf:eth"
  },
  {
    symbol: "USUAL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc4441c2be5d8fa8126822b9929ca0b81ea0de38e",
    sourceId: "27c3158ec3469a041a13ff76e9c0e3fb:eth"
  },
  {
    symbol: "USUALX",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x06b964d96f5dcf7eae9d7c559b09edce244d4b8e",
    sourceId: "91a9b4a7a652c43448e0ffeb04205480:eth"
  },
  {
    symbol: "ABT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
    sourceId: "5be112dfa2fb1af40a0c990c351c2a86:eth"
  },
  {
    symbol: "ACH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xed04915c23f00a313a544955524eb7dbd823143d",
    sourceId: "7c393191397c3d8459da39f357fbcbaa:eth"
  },
  {
    symbol: "AGLD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
    sourceId: "4dbb0f2d19aff354983182a371bb4112:eth"
  },
  {
    symbol: "AIOZ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "x626e8036deb333b408be468f951bdb42433cbf18",
    sourceId: "159933e808f09a043b8ed06429fe89f3:eth"
  },
  {
    symbol: "ALEPH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
    sourceId: "a81f063d6e261ab409d3ae54c702a3bb:eth"
  },
  {
    symbol: "ALICE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xac51066d7bec65dc4589368da368b212745d63e8",
    sourceId: "f2647aca2b3f07f4cbd24731f7243230:eth"
  },
  {
    symbol: "AMP",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
    sourceId: "f13f761208c96a74abf387774505a6b3:eth"
  },
  {
    symbol: "ANT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
    sourceId: "b34b82ace36ee1049b039cf44a867f6f:eth"
  },
  {
    symbol: "APE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4d224452801aced8b2f0aebe155379bb5d594381",
    sourceId: "59cc27fcabc9e674394f57103550e366:eth"
  },
  {
    symbol: "API3",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0b38210ea11411557c13457d4da7dc6ea731b88a",
    sourceId: "f4da6f92b03b99e44ad7dc118b40905c:eth"
  },
  {
    symbol: "AUCTION",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
    sourceId: "3916c831781b4e049b86322bf974c09d:eth"
  },
  {
    symbol: "AURORA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
    sourceId: "5ecfea61a12d03d42bae6d766394dc57:eth"
  },
  {
    symbol: "AUSDC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x98c23e9d8f34fefb1b7bd6a91b7ff122f4e16f5c",
    sourceId: "c93c7789d5dd5e540b753d70dc8d9ce6:eth"
  },
  {
    symbol: "AXS",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
    sourceId: "d0fd50aacc587be4ebc92055b0d11acc:eth"
  },
  {
    symbol: "BAD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x32b86b99441480a7e5bd3a26c124ec2373e3f015",
    sourceId: "cee210dac442c93449156126f3e15f00:eth"
  },
  {
    symbol: "BAND",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
    sourceId: "68fd533b88cfcbf4b93a7a3c007e238b:eth"
  },
  {
    symbol: "BAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
    sourceId: "99a600e980ad1084583006cf1b228a36:eth"
  },
  {
    symbol: "BICO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
    sourceId: "ffc2ed61545c70146a6beda5f917ad40:eth"
  },
  {
    symbol: "BIGTIME",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x64bc2ca1be492be7185faa2c8835d9b824c8a194",
    sourceId: "a20f865b4f0c3fa42b2be19e227aedf0:eth"
  },
  {
    symbol: "BLZ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x5732046a883704404f284ce41ffadd5b007fd668",
    sourceId: "717affb3ed1c4e64986c305600da786e:eth"
  },
  {
    symbol: "BNT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
    sourceId: "5055346ebab6ac74ab53eb79ca951e58:eth"
  },
  {
    symbol: "BOBA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
    sourceId: "301ff220d7afdac4587d60d2d41ca489:eth"
  },
  {
    symbol: "BUSD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
    sourceId: "c09869b0e57fcf14186fe55aba76f044:eth"
  },
  {
    symbol: "C98",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "xae12c5930881c53715b369cec7606b70d8eb229f",
    sourceId: "2f201d01f114fb84ab4eea5d37496e5d:eth"
  },
  {
    symbol: "CBETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
    sourceId: "c9b6f9511de1aa14d969963cc5374273:eth"
  },
  {
    symbol: "CELL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
    sourceId: "2f62f12c956148d45af955a73846e4ba:eth"
  },
  {
    symbol: "CELR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
    sourceId: "2f8297a63eff0d34aad2ab7d888eef1a:eth"
  },
  {
    symbol: "CHZ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
    sourceId: "c220758ce1cb37240962302481fb1b2c:eth"
  },
  {
    symbol: "CLV",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
    sourceId: "2bb42899fced58a47abd0bd83ddc1370:eth"
  },
  {
    symbol: "COMP",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc00e94cb662c3520282e6f5717214004a7f26888",
    sourceId: "8dea7b35b44b4a044bb0e8d154d7226a:eth"
  },
  {
    symbol: "COTI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xddb3422497e61e13543bea06989c0789117555c5",
    sourceId: "42f453b66e690704fbeca15194c3dbab:eth"
  },
  {
    symbol: "COVAL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x3d658390460295fb963f54dc0899cfb1c30776df",
    sourceId: "8542dbb79a0aa434fa63534f7a44db13:eth"
  },
  {
    symbol: "CRO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b",
    sourceId: "77600562f5bc579458183f428173e222:eth"
  },
  {
    symbol: "CRV",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xd533a949740bb3306d119cc777fa900ba034cd52",
    sourceId: "cb75524c32338084895c184bbb97e878:eth"
  },
  {
    symbol: "CRVUSD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
    sourceId: "1c3921966e51976459067140f0859403:eth"
  },
  {
    symbol: "CTSI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
    sourceId: "5285ae9d0e3170b4a8477c150b41d0e3:eth"
  },
  {
    symbol: "CUB",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x00a0be1bbc0c99898df7e6524bf16e893c1e3bb9",
    sourceId: "a2140af9a89f04942a447b2ac0a8d7a3:eth"
  },
  {
    symbol: "DIA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419",
    sourceId: "27de4bb30f5235f49a8d5a223ad6d66d:eth"
  },
  {
    symbol: "DIMO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
    sourceId: "9c13d1a9c37527246a149d916339f7ac:eth"
  },
  {
    symbol: "DNT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0abdace70d3790235af448c88547603b945604ea",
    sourceId: "657af928557967d43ad1cdda801b4b3e:eth"
  },
  {
    symbol: "ELA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
    sourceId: "b1bb19cbfddab2c42b7b8afd2dadb22a:eth"
  },
  {
    symbol: "ENJ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
    sourceId: "7d04124634cfd4e44abb0ef6dc236deb:eth"
  },
  {
    symbol: "FET",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
    sourceId: "8330608a1bee82045a0c73a2fbf9141e:eth"
  },
  {
    symbol: "FLOKI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xcf0c122c6b73ff809c693db761e7baebe62b6a2e",
    sourceId: "62cebd446ab12b44984f349565faad8a:eth"
  },
  {
    symbol: "FORK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7d225c4cc612e61d26523b099b0718d03152edef",
    sourceId: "775602becefa38941ac98018f08ffa1a:eth"
  },
  {
    symbol: "FX",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
    sourceId: "622268947434914408873403045dc698:eth"
  },
  {
    symbol: "GFI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
    sourceId: "482559b3d6d93be498030c0f35c4fe7c:eth"
  },
  {
    symbol: "GLCH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x038a68ff68c393373ec894015816e33ad41bd564",
    sourceId: "0c2744b8dfe188b47bce069ca9e1fea2:eth"
  },
  {
    symbol: "GNO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6810e776880c02933d47db1b9fc05908e5386b96",
    sourceId: "500358ceff09a964589ad1bada9f94f7:eth"
  },
  {
    symbol: "HIGH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
    sourceId: "a778238c3aec30a4ebe3450701ca05eb:eth"
  },
  {
    symbol: "ILV",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
    sourceId: "6d7795b4cf88e0d49a103cb51f0e8b5b:eth"
  },
  {
    symbol: "INJ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
    sourceId: "01167fa80a2cbad4b8931078b0fa2280:eth"
  },
  {
    symbol: "JUP",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4b1e80cac91e2216eeb63e29b957eb91ae9c2be8",
    sourceId: "8ec17f379dc01664db1824df43aed379:eth"
  },
  {
    symbol: "KARRAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xacd2c239012d17beb128b0944d49015104113650",
    sourceId: "3274268ab76a76b4d9d85014135fef82:eth"
  },
  {
    symbol: "KNDX",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7ca5af5ba3472af6049f63c1abc324475d44efc1",
    sourceId: "fdcd2725eead9c244a3f2dadda6294a2:eth"
  },
  {
    symbol: "LDO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    sourceId: "ec6d95ac48e7cd9419c17b584de305c5:eth"
  },
  {
    symbol: "LRC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
    sourceId: "89e4d48633a35864996ea86b93befbd4:eth"
  },
  {
    symbol: "LUNC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9",
    sourceId: "8c4b1596eb55a904080050aec939eed4:eth"
  },
  {
    symbol: "MANA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    sourceId: "e1092dc426bf0204097eb69bcbb14fef:eth"
  },
  {
    symbol: "MATH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
    sourceId: "7393a8a59bdd13546b834cc9f8b89dc3:eth"
  },
  {
    symbol: "MKR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
    sourceId: "2b3e248ae38504e4896d94b4f86a8917:eth"
  },
  {
    symbol: "MMC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x88ee7a3537667958d040216d9dc1752d1274d838",
    sourceId: "65cddb7d8f26752468944c48ca178fb8:eth"
  },
  {
    symbol: "MMR",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x1776e1f26f98b1a5df9cd347953a26dd3cb46671",
    sourceId: "524a840f8d3cd1c4a9ed49b79cd7efc7:eth"
  },
  {
    symbol: "OCEAN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
    sourceId: "02e4e3251c8a08842a29546a122f4f12:eth"
  },
  {
    symbol: "ONDO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xfaba6f8e4a5e8ab82f62fe7c39859fa577269be3",
    sourceId: "67e8605fec48c7446ba698302a1491c0:eth"
  },
  {
    symbol: "OSAK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa21af1050f7b26e0cff45ee51548254c41ed6b5c",
    sourceId: "a0962dfad393e934e8f2da38014f4274:eth"
  },
  {
    symbol: "PLU",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xd8912c10681d8b21fd3742244f44658dba12264e",
    sourceId: "8341ac282abbf4d4f8d2a1c2099aa89a:eth"
  },
  {
    symbol: "PORK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb9f599ce614feb2e1bbe58f180f370d05b39344e",
    sourceId: "f390cbbcfb189cf4d91c6d1007fbfead:eth"
  },
  {
    symbol: "PRIME",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
    sourceId: "49c8f050e84fe4a44a7d55f5edc90007:eth"
  },
  {
    symbol: "PRO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x226bb599a12c826476e3a771454697ea52e9e220",
    sourceId: "0e1cfd0b416b13b4b9cfe64c9694013e:eth"
  },
  {
    symbol: "PYUSD",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x6c3ea9036406852006290770bedfcaba0e23a0e8",
    sourceId: "a8f9a97c2db626247a3daa0aa7b11d09:eth"
  },
  {
    symbol: "QNT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x4a220e6096b25eadb88358cb44068a3248254675",
    sourceId: "7ed8ed4aaaaa55243a8df277235cde3a:eth"
  },
  {
    symbol: "RARI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
    sourceId: "6418b3c6bbc90a6468bc8574a2ab9a68:eth"
  },
  {
    symbol: "RBN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
    sourceId: "5bd12f375af6eaf4f87b49f3c3954e45:eth"
  },
  {
    symbol: "RETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xae78736cd615f374d3085123a210448e74fc6393",
    sourceId: "c79435b71e7a1344e9c65f8892de5ada:eth"
  },
  {
    symbol: "RING",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc092a137df3cf2b9e5971ba1874d26487c12626d",
    sourceId: "edf28fa30755cc1459b31908ee4ae39c:eth"
  },
  {
    symbol: "SCALE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8a0a9b663693a22235b896f70a229c4a22597623",
    sourceId: "7c5309052988d624dae6faa9973e1044:eth"
  },
  {
    symbol: "SETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb",
    sourceId: "9de098b39ff59a04caf191d274f2646b:eth"
  },
  {
    symbol: "SKL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
    sourceId: "3b06436b45036ae42b3a2b010f82e121:eth"
  },
  {
    symbol: "SNX",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
    sourceId: "f274f2feeea135f4896db34bb54a226b:eth"
  },
  {
    symbol: "STORJ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
    sourceId: "1747cc448b0408e438daa3d02f8281c6:eth"
  },
  {
    symbol: "SUSD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
    sourceId: "2bfceb9b142e51c4da19d37e3d4419d5:eth"
  },
  {
    symbol: "SYLO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
    sourceId: "a4afa5544baf84f4e965adf1730d7993:eth"
  },
  {
    symbol: "TRAC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
    sourceId: "dd103b6a07eba97479887f3f561fd4a7:eth"
  },
  {
    symbol: "TRU",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf65b5c5104c4fafd4b709d9d60a185eae063276c",
    sourceId: "3602af3e76939c54ea494c30d27978b4:eth"
  },
  {
    symbol: "UMA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x04fa0d235c4abf4bcf4787af4cf447de572ef828",
    sourceId: "6776887159832b64187e9316825d4762:eth"
  },
  {
    symbol: "UNFI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x441761326490cacf7af299725b6292597ee822c2",
    sourceId: "5622c8b91c4fab1409c358894ce95f73:eth"
  },
  {
    symbol: "USTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xa47c8bf37f92abed4a126bda807a7b7498661acd",
    sourceId: "f01d7bc331631d9489058ccd9c3d347e:eth"
  },
  {
    symbol: "WBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    sourceId: "6c90154efd460e14baf6a58981710259:eth"
  },
  {
    symbol: "WBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
    sourceId: "6c90154efd460e14baf6a58981710259:solana"
  },
  {
    symbol: "WLD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x163f8c2467924be0ae7b5347228cabf260318753",
    sourceId: "87a70927e5a777b4598346c091e4e616:eth"
  },
  {
    symbol: "WSTETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
    sourceId: "6cc70b9a5361d174cb68c6f2ed19036a:eth"
  },
  {
    symbol: "YAI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x477a3d269266994f15e9c43a8d9c0561c4928088",
    sourceId: "f3b82afcdcae3ae48826394d671b1e7b:eth"
  },
  {
    symbol: "ZETA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf091867ec603a6628ed83d274e835539d82e9cc8",
    sourceId: "a6d8a08b5f4e6e24d9407841f55919a6:eth"
  },
  {
    symbol: "ZKML",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xe92344b4edf545f3209094b192e46600a19e7c2d",
    sourceId: "b85131b32f01b7f41b44427e6ceb575a:eth"
  },
  {
    symbol: "ZRO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x6985884c4392d348587b19cb9eaaf157f13271cd",
    sourceId: "a9db2e548c99b8e42b3f9aa6b8e61643:eth"
  },
  {
    symbol: "AETHLIDOWETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xfa1fdbbd71b0aa16162d76914d69cd8cb3ef92da",
    sourceId: "f82d8c037aa46b644be8c8479e96eb2b:eth"
  },
  {
    symbol: "AETHLIDOWSTETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc035a7cf15375ce2706766804551791ad035e0c2",
    sourceId: "80b218f59c3c5f04fa357ef99dcafbba:eth"
  },
  {
    symbol: "WAETHLIDOWSTETH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x0fe906e030a44ef24ca8c7dc7b7c53a6c4f00ce9",
    sourceId: "1d8c637c49e63c4438c0b151de7f971a:eth"
  },
  {
    symbol: "REKT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xdd3b11ef34cd511a2da159034a05fcb94d806686",
    sourceId: "8b163ff412ff7904ca1e66d68bbb1cc1:eth"
  },
  {
    symbol: "YT-WEETH-27JUN2024",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xfb35fd0095dd1096b1ca49ad44d8c5812a201677",
    sourceId: "b598024091743734880b3e25fdee32a0:eth"
  },
  {
    symbol: "FAKEUSDT1",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x7ed878720bf98fe135e743c0eb3c48e64f9be5ae",
    sourceId: "cd882deb6098e874abf05e24f31b7ffa:eth"
  },
  {
    symbol: "FAKEUSDT1",
    decimals: 6,
    chainKey: "ton",
    contractAddress: "EQAvyxivzg2NpdALy6tcWZLfr6_uOJgvjCkOdjYU7enOXm-m",
    sourceId: "cd882deb6098e874abf05e24f31b7ffa:ton"
  },
  {
    symbol: "FAKEUSDT2",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x7f56f0539b3041624141bc1159e43e2b16d1a7cc",
    sourceId: "7d186d4cedbdeb74397a1651497756bd:eth"
  },
  {
    symbol: "FAKEUSDT2",
    decimals: 6,
    chainKey: "ton",
    contractAddress: "EQCP5xiDLns_P8B2kTBWT50uRb01l6lsli3YyvsFx5RPFHka",
    sourceId: "7d186d4cedbdeb74397a1651497756bd:ton"
  },
  {
    symbol: "FAKEUSDT3",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x718da2a140aa4719abd4d0b532168140849c6c1c",
    sourceId: "2e62349edab30a242a0ab8a0f16d0494:eth"
  },
  {
    symbol: "FAKEUSDT3",
    decimals: 6,
    chainKey: "ton",
    contractAddress: "EQAx0FLsExzvM0-cRlq6DkGfQfTwmaZrJTpkjt-Fu8FuMWAG",
    sourceId: "2e62349edab30a242a0ab8a0f16d0494:ton"
  },
  {
    symbol: "FAKEUSDT4",
    decimals: 6,
    chainKey: "evm:1",
    contractAddress: "0x5c523661cbf5a0e33260db4316a36e6bb598dc15",
    sourceId: "4a0bb8f146e765645b1944433f4aa8fc:eth"
  },
  {
    symbol: "FAKEUSDT4",
    decimals: 6,
    chainKey: "ton",
    contractAddress: "EQBswm-soEg0qM-yj3zY9_3AvF6RgTP2tvRsgDgC5QFl1wP-",
    sourceId: "4a0bb8f146e765645b1944433f4aa8fc:ton"
  },
  {
    symbol: "RENBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xeb4c2781e4eba804ce9a9803c67d0893436bb27d",
    sourceId: "c7a936714b8067940900285630eb2b96:eth"
  },
  {
    symbol: "RENBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "CDJWUqTcYTVAKXAVXoQZFes5JUFc7owSeq7eMQcDSbo5",
    sourceId: "c7a936714b8067940900285630eb2b96:solana"
  },
  {
    symbol: "FRAX",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x853d955acef822db058eb8505911ed77f175b99e",
    sourceId: "8deb19fb4055d394689fd9c6c9792744:eth"
  },
  {
    symbol: "G-UNI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb1cfdc7370550f5e421e1bf0bf3cadfadf3c4141",
    sourceId: "e0037a4f3ce40644683fc6f5699d28ef:eth"
  },
  {
    symbol: "BTC.B",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x152b9d0fdc40c096757f570a51e494bd4b943e50",
    sourceId: "8e2073de918529145bab3d84a11bb6f1:eth"
  },
  {
    symbol: "BTC.B",
    decimals: 10,
    chainKey: "evm:43114",
    contractAddress: "0x152b9d0fdc40c096757f570a51e494bd4b943e50",
    sourceId: "8e2073de918529145bab3d84a11bb6f1:avax"
  },
  {
    symbol: "HBZ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xe34e1944e776f39b9252790a0527ebda647ae668",
    sourceId: "eb293814624a96645b1940166501581e:eth"
  },
  {
    symbol: "AIUS",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xe3dbc4f88eaa632ddf9708732e2832eeaa6688ab",
    sourceId: "643ea96e06d08244e96f35482b166773:eth"
  },
  {
    symbol: "SORA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xb8a87405d9a4f2f866319b77004e88dff66c0d92",
    sourceId: "00892287bd926484a87b4535e3bf951f:eth"
  },
  {
    symbol: "USDT.E",
    decimals: 12,
    chainKey: "evm:1",
    contractAddress: "0xc7198437980c041c805a1edcba50c1ce5db95118",
    sourceId: "50c2158e38637a14d963bd75e06c9bd5:eth"
  },
  {
    symbol: "USDT.E",
    decimals: 12,
    chainKey: "tron",
    contractAddress: "0xc7198437980c041c805a1edcba50c1ce5db95118",
    sourceId: "50c2158e38637a14d963bd75e06c9bd5:tron"
  },
  {
    symbol: "USDT.E",
    decimals: 12,
    chainKey: "ton",
    contractAddress: "0xc7198437980c041c805a1edcba50c1ce5db95118",
    sourceId: "50c2158e38637a14d963bd75e06c9bd5:ton"
  },
  {
    symbol: "USDT.E",
    decimals: 12,
    chainKey: "evm:43114",
    contractAddress: "0xc7198437980c041c805a1edcba50c1ce5db95118",
    sourceId: "50c2158e38637a14d963bd75e06c9bd5:avax"
  },
  {
    symbol: "FET",
    decimals: 12,
    chainKey: "tron",
    contractAddress: "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
    sourceId: "2f5ec4421d0660547b067328c5c9c337:tron"
  },
  {
    symbol: "FET",
    decimals: 12,
    chainKey: "ton",
    contractAddress: "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
    sourceId: "2f5ec4421d0660547b067328c5c9c337:ton"
  },
  {
    symbol: "FET",
    decimals: 12,
    chainKey: "evm:43114",
    contractAddress: "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
    sourceId: "2f5ec4421d0660547b067328c5c9c337:avax"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "TCFNp179Lg46D16zKoumd4Poa2WFFdtqYj",
    sourceId: "266a93d1fad86504fa0497686e611c1e:eth"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "tron",
    contractAddress: "TXDk8mbtRbXeYuMNS83CfKPaYYT8XWv9Hz",
    sourceId: "266a93d1fad86504fa0497686e611c1e:tron"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "pulsechain",
    contractAddress: "TCFNp179Lg46D16zKoumd4Poa2WFFdtqYj",
    sourceId: "266a93d1fad86504fa0497686e611c1e:pulsechain"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "ton",
    contractAddress: "TCFNp179Lg46D16zKoumd4Poa2WFFdtqYj",
    sourceId: "266a93d1fad86504fa0497686e611c1e:ton"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "evm:43114",
    contractAddress: "TCFNp179Lg46D16zKoumd4Poa2WFFdtqYj",
    sourceId: "266a93d1fad86504fa0497686e611c1e:avax"
  },
  {
    symbol: "USDD",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "TCFNp179Lg46D16zKoumd4Poa2WFFdtqYj",
    sourceId: "266a93d1fad86504fa0497686e611c1e:solana"
  },
  {
    symbol: "$PAAL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x14fee680690900ba0cccfc76ad70fd1b95d10e16",
    sourceId: "7e5727f21a2718c44925ef2b113b1d49:eth"
  },
  {
    symbol: "SFI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x7636d8722fdf7cd34232a915e48e96aa3eb386bf",
    sourceId: "4e9bcbb81a11b3047828a6694fc06d36:eth"
  },
  {
    symbol: "SIDUS",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x549020a9cb845220d66d3e9c6d9f9ef61c981102",
    sourceId: "36491970d495d424ab7bc2de7d7245bf:eth"
  },
  {
    symbol: "SNSY",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x82a605d6d9114f4ad6d5ee461027477eeed31e34",
    sourceId: "dab7a16ce439ec94ab6380334c951b2c:eth"
  },
  {
    symbol: "GPU",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x1258d60b224c0c5cd888d37bbf31aa5fcfb7e870",
    sourceId: "88e4062b0aaff1c47833d830135f76a8:eth"
  },
  {
    symbol: "CAH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0x8e0e57dcb1ce8d9091df38ec1bfc3b224529754a",
    sourceId: "9997953c2d5423c488cfad8c844b419b:eth"
  },
  {
    symbol: "DSYNC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf94e7d0710709388bce3161c32b4eea56d3f91cc",
    sourceId: "623bd608197fdfa41b02478b6fe4614a:eth"
  },
  {
    symbol: "PALM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xf1df7305e4bab3885cab5b1e4dfc338452a67891",
    sourceId: "a277f79bae3bbd147942203fa4aea774:eth"
  },
  {
    symbol: "GME",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xc56c7a0eaa804f854b536a5f3d5f49d2ec4b12b8",
    sourceId: "78dcd0fe908101f4896103127308126b:eth"
  },
  {
    symbol: "BTC2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "0xbc2ecbe2195114b82f03680ed4270fa7008f3be0",
    sourceId: "bb1adfe5a84691a41b62d903618caf83:eth"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:eth"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "tron",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:tron"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "pulsechain",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:pulsechain"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "ton",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:ton"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "evm:43114",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:avax"
  },
  {
    symbol: "ICD",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "TPRuU2GbXPwvvSuggE4xKMRtzsfwYfvBWq",
    sourceId: "80dbfc6d7479c864b92e892195baaa94:solana"
  },
  {
    symbol: "21BTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "21BTCo9hWHjGYYUQQLqjLgDBxjcn8vDt4Zic7TB3UbNE",
    sourceId: "f4e40b789e9b28b449cb65430478a39f:eth"
  },
  {
    symbol: "21BTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "21BTCo9hWHjGYYUQQLqjLgDBxjcn8vDt4Zic7TB3UbNE",
    sourceId: "f4e40b789e9b28b449cb65430478a39f:solana"
  },
  {
    symbol: "AMARAGOLDBROWN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "7ovusKCfPtZsievLyM7VahjuC1BPwjwvSKLnx4A8X6iZ",
    sourceId: "47842257f6818b64cbbfda14f0611aee:eth"
  },
  {
    symbol: "AMARAGOLDBROWN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "7ovusKCfPtZsievLyM7VahjuC1BPwjwvSKLnx4A8X6iZ",
    sourceId: "47842257f6818b64cbbfda14f0611aee:solana"
  },
  {
    symbol: "BONK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    sourceId: "41d714850ac574748a30021e644729f0:eth"
  },
  {
    symbol: "BONK",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    sourceId: "41d714850ac574748a30021e644729f0:solana"
  },
  {
    symbol: "BONKBOXES",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "FH1Sb3iEqsJTpE8nd3NdSNU9RF6tjCd2JXBXVNaoUnJR",
    sourceId: "7bc704e7426b9b94e8f3ef4ce234b434:eth"
  },
  {
    symbol: "BONKBOXES",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "FH1Sb3iEqsJTpE8nd3NdSNU9RF6tjCd2JXBXVNaoUnJR",
    sourceId: "7bc704e7426b9b94e8f3ef4ce234b434:solana"
  },
  {
    symbol: "BONKEARN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "CKfatsPMUf8SkiURsDXs7eK6GWb4Jsd6UDbs7twMCWxo",
    sourceId: "80a14a562eb36be428e4f0a774c13fc3:eth"
  },
  {
    symbol: "BONKEARN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "CKfatsPMUf8SkiURsDXs7eK6GWb4Jsd6UDbs7twMCWxo",
    sourceId: "80a14a562eb36be428e4f0a774c13fc3:solana"
  },
  {
    symbol: "CATWIFHAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "7atgF8KQo4wJrD5ATGX7t1V2zVvykPJbFfNeVf1icFv1",
    sourceId: "218a42d2cf7d2e745bf704ceffb098c9:eth"
  },
  {
    symbol: "CATWIFHAT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "7atgF8KQo4wJrD5ATGX7t1V2zVvykPJbFfNeVf1icFv1",
    sourceId: "218a42d2cf7d2e745bf704ceffb098c9:solana"
  },
  {
    symbol: "CBBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "cbbtcf3aa214zXHbiAZQwf4122FBYbraNdFqgw4iMij",
    sourceId: "9da512551aa7d0b43aeeffe15b9cdac6:eth"
  },
  {
    symbol: "CBBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "cbbtcf3aa214zXHbiAZQwf4122FBYbraNdFqgw4iMij",
    sourceId: "9da512551aa7d0b43aeeffe15b9cdac6:solana"
  },
  {
    symbol: "CECILTHELION",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "GPzvszRyF6Dr3EwiQMokd7d8mKWykfv8SCWrB9hQjb6y",
    sourceId: "26163cbe3d29f6a4a83242c9535fea66:eth"
  },
  {
    symbol: "CECILTHELION",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "GPzvszRyF6Dr3EwiQMokd7d8mKWykfv8SCWrB9hQjb6y",
    sourceId: "26163cbe3d29f6a4a83242c9535fea66:solana"
  },
  {
    symbol: "CHILI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "GPyzPHuFFGvN4yWWixt6TYUtDG49gfMdFFi2iniTmCkh",
    sourceId: "4960134ad21ed4e4ea64b3e047dfd06b:eth"
  },
  {
    symbol: "CHILI",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "GPyzPHuFFGvN4yWWixt6TYUtDG49gfMdFFi2iniTmCkh",
    sourceId: "4960134ad21ed4e4ea64b3e047dfd06b:solana"
  },
  {
    symbol: "CHONKY",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "H7ed7UgcLp3ax4X1CQ5WuWDn6d1pprfMMYiv5ejwLWWU",
    sourceId: "1562641cbe11f3d48b9e205296d18ba7:eth"
  },
  {
    symbol: "CHONKY",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "H7ed7UgcLp3ax4X1CQ5WuWDn6d1pprfMMYiv5ejwLWWU",
    sourceId: "1562641cbe11f3d48b9e205296d18ba7:solana"
  },
  {
    symbol: "COPE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "o1Mw5Y3n68o8TakZFuGKLZMGjm72qv4JeoZvGiCLEvK",
    sourceId: "02cbf76394048d34ca68d7765cbc74b0:eth"
  },
  {
    symbol: "COPE",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "o1Mw5Y3n68o8TakZFuGKLZMGjm72qv4JeoZvGiCLEvK",
    sourceId: "02cbf76394048d34ca68d7765cbc74b0:solana"
  },
  {
    symbol: "CYBURTRUK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "GoWgyQHMH3sWexTZq7QY8J6XLymekamWc667VVLXpysw",
    sourceId: "8d3700165f3b35741836376f88fe4125:eth"
  },
  {
    symbol: "CYBURTRUK",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "GoWgyQHMH3sWexTZq7QY8J6XLymekamWc667VVLXpysw",
    sourceId: "8d3700165f3b35741836376f88fe4125:solana"
  },
  {
    symbol: "DEGENLIVESMATTER",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "DEGENmyjCpmyrVurnbSKjWyk9SQ2WfQNUMXESN61PqjV",
    sourceId: "c807057f35af7a34da7cbc4debcb4983:eth"
  },
  {
    symbol: "DEGENLIVESMATTER",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "DEGENmyjCpmyrVurnbSKjWyk9SQ2WfQNUMXESN61PqjV",
    sourceId: "c807057f35af7a34da7cbc4debcb4983:solana"
  },
  {
    symbol: "DOGGO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "Doggoyb1uHFJGFdHhJf8FKEBUMv58qo98CisWgeD7Ftk",
    sourceId: "9574ab951c9a9634b89bed60ff95cff6:eth"
  },
  {
    symbol: "DOGGO",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "Doggoyb1uHFJGFdHhJf8FKEBUMv58qo98CisWgeD7Ftk",
    sourceId: "9574ab951c9a9634b89bed60ff95cff6:solana"
  },
  {
    symbol: "DRAKO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "drakduQWnTS89CdTUdgHmZzEkN6reBLYqrk8rzVhU53",
    sourceId: "b7d4cfb23c9d4594fa7e888700780328:eth"
  },
  {
    symbol: "DRAKO",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "drakduQWnTS89CdTUdgHmZzEkN6reBLYqrk8rzVhU53",
    sourceId: "b7d4cfb23c9d4594fa7e888700780328:solana"
  },
  {
    symbol: "GECKO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "6CNHDCzD5RkvBWxxyokQQNQPjFWgoHF94D7BmC73X6ZK",
    sourceId: "25dcfef6843638348b41d6b9c49165d8:eth"
  },
  {
    symbol: "GECKO",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "6CNHDCzD5RkvBWxxyokQQNQPjFWgoHF94D7BmC73X6ZK",
    sourceId: "25dcfef6843638348b41d6b9c49165d8:solana"
  },
  {
    symbol: "JUNGLE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "Aogv6j1wWiBAZcqRNN1Y89eozda2ke6rkc4CYy7c4iCi",
    sourceId: "f159284b94d67cb4880add261593095a:eth"
  },
  {
    symbol: "JUNGLE",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "Aogv6j1wWiBAZcqRNN1Y89eozda2ke6rkc4CYy7c4iCi",
    sourceId: "f159284b94d67cb4880add261593095a:solana"
  },
  {
    symbol: "JUPFINALLY",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "AWTG6pHHN42Krk9VyZChEEdziPxyYN9pDcWYDE1jwpP5",
    sourceId: "66a729b1299810b41a980ffb04c0ceee:eth"
  },
  {
    symbol: "JUPFINALLY",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "AWTG6pHHN42Krk9VyZChEEdziPxyYN9pDcWYDE1jwpP5",
    sourceId: "66a729b1299810b41a980ffb04c0ceee:solana"
  },
  {
    symbol: "KININU",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "inuXXDC6Tw1Fu6qUAfRbELG5x5pSA4afTskf7MvwjhN",
    sourceId: "639b720cacc5f014a82e47f504406b84:eth"
  },
  {
    symbol: "KININU",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "inuXXDC6Tw1Fu6qUAfRbELG5x5pSA4afTskf7MvwjhN",
    sourceId: "639b720cacc5f014a82e47f504406b84:solana"
  },
  {
    symbol: "KINGOFMEMES",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "6HTm4HZfgGaQegKs2CQ3x6NwVGAJp93YEP8Jh1TxKWeU",
    sourceId: "bf8ca0ba14fe6744f9620d726fa2554e:eth"
  },
  {
    symbol: "KINGOFMEMES",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "6HTm4HZfgGaQegKs2CQ3x6NwVGAJp93YEP8Jh1TxKWeU",
    sourceId: "bf8ca0ba14fe6744f9620d726fa2554e:solana"
  },
  {
    symbol: "LBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "LBTCgU4b3wsFKsPwBn1rRZDx5DoFutM6RPiEt1TPDsY",
    sourceId: "e45907e747fc7944ea6bb52321721572:eth"
  },
  {
    symbol: "LBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "LBTCgU4b3wsFKsPwBn1rRZDx5DoFutM6RPiEt1TPDsY",
    sourceId: "e45907e747fc7944ea6bb52321721572:solana"
  },
  {
    symbol: "LORMTHEWORM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "2emYMetySwE7Xh6qrG1AwAQ3TDvrLkUSpSZ5AjcWCc7B",
    sourceId: "4a367b3e7d68131449882862e3dbbb82:eth"
  },
  {
    symbol: "LORMTHEWORM",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "2emYMetySwE7Xh6qrG1AwAQ3TDvrLkUSpSZ5AjcWCc7B",
    sourceId: "4a367b3e7d68131449882862e3dbbb82:solana"
  },
  {
    symbol: "MARINADE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    sourceId: "a8af683c4fdbe0b448ec727987ef3896:eth"
  },
  {
    symbol: "MARINADE",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    sourceId: "a8af683c4fdbe0b448ec727987ef3896:solana"
  },
  {
    symbol: "MSOL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    sourceId: "d2f70d7fae92d474fae43022c07e6b91:eth"
  },
  {
    symbol: "MSOL",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    sourceId: "d2f70d7fae92d474fae43022c07e6b91:solana"
  },
  {
    symbol: "NANA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "6uZ7MRGGf3FJhzk9TUk3QRMR2fz83WY9BEVBukRvMRVX",
    sourceId: "c97c3b08834c8bf4e9f384d9d067e369:eth"
  },
  {
    symbol: "NANA",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "6uZ7MRGGf3FJhzk9TUk3QRMR2fz83WY9BEVBukRvMRVX",
    sourceId: "c97c3b08834c8bf4e9f384d9d067e369:solana"
  },
  {
    symbol: "NFT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "7MC1kwNJaScpMw1QukdeD48rSp7cE3NgxZ2yKdDBPqQe",
    sourceId: "1fc0ca3477ba993429dbfb487a278241:eth"
  },
  {
    symbol: "NFT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "7MC1kwNJaScpMw1QukdeD48rSp7cE3NgxZ2yKdDBPqQe",
    sourceId: "1fc0ca3477ba993429dbfb487a278241:solana"
  },
  {
    symbol: "ONI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "GNG1aKJausQZQHjvBrkPY7XWF4MCtcCfzzGHz5YXZn3R",
    sourceId: "6d7f6ab478039b640864e58046518d21:eth"
  },
  {
    symbol: "ONI",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "GNG1aKJausQZQHjvBrkPY7XWF4MCtcCfzzGHz5YXZn3R",
    sourceId: "6d7f6ab478039b640864e58046518d21:solana"
  },
  {
    symbol: "OOGI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "H7Qc9APCWWGDVxGD5fJHmLTmdEgT9GFatAKFNg6sHh8A",
    sourceId: "0763f5eb17bf74541aeb18bfde41c32d:eth"
  },
  {
    symbol: "OOGI",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "H7Qc9APCWWGDVxGD5fJHmLTmdEgT9GFatAKFNg6sHh8A",
    sourceId: "0763f5eb17bf74541aeb18bfde41c32d:solana"
  },
  {
    symbol: "ORCA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "Baj2ueGuSwdKhdCsJrf7xvGBbUSpmpySYewQLbsiNs2Y",
    sourceId: "bdf95b015027a2045934318d396f0080:eth"
  },
  {
    symbol: "ORCA",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "Baj2ueGuSwdKhdCsJrf7xvGBbUSpmpySYewQLbsiNs2Y",
    sourceId: "bdf95b015027a2045934318d396f0080:solana"
  },
  {
    symbol: "ORCAWALL",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "4HxRBHMeyhiEYWBUs53ekS2WSRUwvgdkEfNR3khzsYmb",
    sourceId: "ac80f55408fc4574db65ff720801c8c6:eth"
  },
  {
    symbol: "ORCAWALL",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "4HxRBHMeyhiEYWBUs53ekS2WSRUwvgdkEfNR3khzsYmb",
    sourceId: "ac80f55408fc4574db65ff720801c8c6:solana"
  },
  {
    symbol: "ORCAWALL2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "H6xPnHrnfmiYqxYdM8j8VYY981r5yJ2R2aZfZq4bNCR1",
    sourceId: "f4576dc4d615ff749b204a389c84c04a:eth"
  },
  {
    symbol: "ORCAWALL2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "H6xPnHrnfmiYqxYdM8j8VYY981r5yJ2R2aZfZq4bNCR1",
    sourceId: "f4576dc4d615ff749b204a389c84c04a:solana"
  },
  {
    symbol: "PUGAI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "PugAiDuaQ5hzicBHAW9qrQQ8qi4B6sh3n7PknKhyjeX",
    sourceId: "ef76c6266d55e9e4981aed5d76e1ba30:eth"
  },
  {
    symbol: "PUGAI",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "PugAiDuaQ5hzicBHAW9qrQQ8qi4B6sh3n7PknKhyjeX",
    sourceId: "ef76c6266d55e9e4981aed5d76e1ba30:solana"
  },
  {
    symbol: "REDACTIO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "EVAknb8Rc3GsZC4yz36C9qXDUJbJDtGmgacjF5H6Mi8i",
    sourceId: "7cb96798ec00c92428e0d6c666d5b63d:eth"
  },
  {
    symbol: "REDACTIO",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "EVAknb8Rc3GsZC4yz36C9qXDUJbJDtGmgacjF5H6Mi8i",
    sourceId: "7cb96798ec00c92428e0d6c666d5b63d:solana"
  },
  {
    symbol: "REMILIO",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "remiG7sGaHWgrY7o6SXJW5CYi5A7kmKutyJz6x6hUsp",
    sourceId: "1111cc4dfebdb6648be85bf9217ba3e7:eth"
  },
  {
    symbol: "REMILIO",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "remiG7sGaHWgrY7o6SXJW5CYi5A7kmKutyJz6x6hUsp",
    sourceId: "1111cc4dfebdb6648be85bf9217ba3e7:solana"
  },
  {
    symbol: "SAUCE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "427xvZVKbFj7ZyfFoYS9iFpNuNsrijm6T9VP8znfko9j",
    sourceId: "cfb25fdd1235ec449b86f4fd3b22859a:eth"
  },
  {
    symbol: "SAUCE",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "427xvZVKbFj7ZyfFoYS9iFpNuNsrijm6T9VP8znfko9j",
    sourceId: "cfb25fdd1235ec449b86f4fd3b22859a:solana"
  },
  {
    symbol: "SHIBWIFHAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "F6qoefQq4iCBLoNZ34RjEqHjHkD8vtmoRSdw9Nd55J1k",
    sourceId: "6087c7eccc3516c4f8436dbb22d6b3f5:eth"
  },
  {
    symbol: "SHIBWIFHAT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "F6qoefQq4iCBLoNZ34RjEqHjHkD8vtmoRSdw9Nd55J1k",
    sourceId: "6087c7eccc3516c4f8436dbb22d6b3f5:solana"
  },
  {
    symbol: "SIZE",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "HqLRjru6pD6GFGnQ7TwSSGQRuPhF8UZNey9T4yCsZzuq",
    sourceId: "6c4af3d5cd1a0a840b83d2ec49ca0c98:eth"
  },
  {
    symbol: "SIZE",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "HqLRjru6pD6GFGnQ7TwSSGQRuPhF8UZNey9T4yCsZzuq",
    sourceId: "6c4af3d5cd1a0a840b83d2ec49ca0c98:solana"
  },
  {
    symbol: "SOLANACASH",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "SCHEvu47HruoNsRSUpBim58UDRFmeGRBAEvRzYLaAKE",
    sourceId: "eebd649262b84f74da8b0a64b9896677:eth"
  },
  {
    symbol: "SOLANACASH",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "SCHEvu47HruoNsRSUpBim58UDRFmeGRBAEvRzYLaAKE",
    sourceId: "eebd649262b84f74da8b0a64b9896677:solana"
  },
  {
    symbol: "SOLCASINOUSD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "21jZ1ESEFYh9SBwjT5gqE3jHv3JnaGhgvypLTR96QXW9",
    sourceId: "a5c6fb05dd451024397e49e5696b5405:eth"
  },
  {
    symbol: "SOLCASINOUSD",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "21jZ1ESEFYh9SBwjT5gqE3jHv3JnaGhgvypLTR96QXW9",
    sourceId: "a5c6fb05dd451024397e49e5696b5405:solana"
  },
  {
    symbol: "SPAMTOKEN1",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "CT4BJTcwKDa5P19Cq4uqDK8hcBwWooB2rnDyTAXvXT5K",
    sourceId: "c566359e792316342aef8612b32a0d8c:eth"
  },
  {
    symbol: "SPAMTOKEN1",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "CT4BJTcwKDa5P19Cq4uqDK8hcBwWooB2rnDyTAXvXT5K",
    sourceId: "c566359e792316342aef8612b32a0d8c:solana"
  },
  {
    symbol: "TBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU",
    sourceId: "6ffb55bd02359c642a0c146f3cc88b55:eth"
  },
  {
    symbol: "TBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU",
    sourceId: "6ffb55bd02359c642a0c146f3cc88b55:solana"
  },
  {
    symbol: "TOOKERKURLSON",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "9EYScpiysGnEimnQPzazr7Jn9GVfxFYzgTEj85hV9L6U",
    sourceId: "84ad48ed0bf5acf4a857558effcb4c54:eth"
  },
  {
    symbol: "TOOKERKURLSON",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "9EYScpiysGnEimnQPzazr7Jn9GVfxFYzgTEj85hV9L6U",
    sourceId: "84ad48ed0bf5acf4a857558effcb4c54:solana"
  },
  {
    symbol: "VANCAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "GREE1xhoGvX9wUBKNQNpu5PLWG57NtzmxSTEkKML6agV",
    sourceId: "96901f982e72257409b21b27616d8916:eth"
  },
  {
    symbol: "VANCAT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "GREE1xhoGvX9wUBKNQNpu5PLWG57NtzmxSTEkKML6agV",
    sourceId: "96901f982e72257409b21b27616d8916:solana"
  },
  {
    symbol: "WBTC2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    sourceId: "64f41a8b92926e14aa78aa777190465c:eth"
  },
  {
    symbol: "WBTC2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    sourceId: "64f41a8b92926e14aa78aa777190465c:solana"
  },
  {
    symbol: "WBTC3",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "5XZw2LKTyrfvfiskJ78AMpackRjPcyCif1WhUsPDuVqQ",
    sourceId: "76f24e0ef929d044593cb41916298809:eth"
  },
  {
    symbol: "WBTC3",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "5XZw2LKTyrfvfiskJ78AMpackRjPcyCif1WhUsPDuVqQ",
    sourceId: "76f24e0ef929d044593cb41916298809:solana"
  },
  {
    symbol: "XBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "CtzPWv73Sn1dMGVU3ZtLv9yWSyUAanBni19YWDaznnkn",
    sourceId: "f15b8484204757d45953daaae4dd07bb:eth"
  },
  {
    symbol: "XBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "CtzPWv73Sn1dMGVU3ZtLv9yWSyUAanBni19YWDaznnkn",
    sourceId: "f15b8484204757d45953daaae4dd07bb:solana"
  },
  {
    symbol: "ZBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "zBTCug3er3tLyffELcvDNrKkCymbPWysGcWihESYfLg",
    sourceId: "09d0cf68596a5e048831c6b9c38dd859:eth"
  },
  {
    symbol: "ZBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "zBTCug3er3tLyffELcvDNrKkCymbPWysGcWihESYfLg",
    sourceId: "09d0cf68596a5e048831c6b9c38dd859:solana"
  },
  {
    symbol: "ZENBTC",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "9hX59xHHnaZXLU6quvm5uGY2iDiT3jczaReHy6A6TYKw",
    sourceId: "04e34fb246239654f956459f9e07490c:eth"
  },
  {
    symbol: "ZENBTC",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "9hX59xHHnaZXLU6quvm5uGY2iDiT3jczaReHy6A6TYKw",
    sourceId: "04e34fb246239654f956459f9e07490c:solana"
  },
  {
    symbol: "FTT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    sourceId: "c1e453626c3f19a45ab7a30705e199b1:eth"
  },
  {
    symbol: "FTT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
    sourceId: "c1e453626c3f19a45ab7a30705e199b1:solana"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "9LhS9DS7i8iVRfzejBHuaKKnTpauBamDAaD4BpQyPMKB",
    sourceId: "217ed19da214c9246b66333db9252bef:eth"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "9LhS9DS7i8iVRfzejBHuaKKnTpauBamDAaD4BpQyPMKB",
    sourceId: "217ed19da214c9246b66333db9252bef:solana"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "2rv2U2Kqgzeg3MLTvayj5QbNAKdW5hsZ8EVxwS6P7Gv3",
    sourceId: "2e3890f694c4f1c48bf6904f3c0a17cc:eth"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "2rv2U2Kqgzeg3MLTvayj5QbNAKdW5hsZ8EVxwS6P7Gv3",
    sourceId: "2e3890f694c4f1c48bf6904f3c0a17cc:solana"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "5TqiLwnEhhbQnTmJkUpedFX6o2g3SXceHp8dpQEBc5LV",
    sourceId: "aefbb3ab1bf538b4a91e877804b3e5dc:eth"
  },
  {
    symbol: "JUPFINALLY2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "5TqiLwnEhhbQnTmJkUpedFX6o2g3SXceHp8dpQEBc5LV",
    sourceId: "aefbb3ab1bf538b4a91e877804b3e5dc:solana"
  },
  {
    symbol: "LUNA",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "F6v4wfAdJB8D8p77bMXZgYt8TDKsYxLYxH5AFhUkYx9W",
    sourceId: "ebfc830b5e176a2488ef6a367136c681:eth"
  },
  {
    symbol: "LUNA",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "F6v4wfAdJB8D8p77bMXZgYt8TDKsYxLYxH5AFhUkYx9W",
    sourceId: "ebfc830b5e176a2488ef6a367136c681:solana"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "3ei5pLMmWUMRQPqcsyoVzLMnFUzfoxLYNV5P5vdyUvdW",
    sourceId: "487bc35673a2bfa47919c5c2893b10d3:eth"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "3ei5pLMmWUMRQPqcsyoVzLMnFUzfoxLYNV5P5vdyUvdW",
    sourceId: "487bc35673a2bfa47919c5c2893b10d3:solana"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "wMtnNCWYvnYBU7fd2P8iqvW8SbB6dJxtNLpiua7oF4G",
    sourceId: "f266408efd03f364ea2ac55fd9f46652:eth"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "wMtnNCWYvnYBU7fd2P8iqvW8SbB6dJxtNLpiua7oF4G",
    sourceId: "f266408efd03f364ea2ac55fd9f46652:solana"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "8FxaJPqKGmP5p8awPsXn1S8KLjdLyAFiq3eR8okqQ3EB",
    sourceId: "c897dbb5bfaac7949a5d1adf383007c5:eth"
  },
  {
    symbol: "RAYDIUM",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "8FxaJPqKGmP5p8awPsXn1S8KLjdLyAFiq3eR8okqQ3EB",
    sourceId: "c897dbb5bfaac7949a5d1adf383007c5:solana"
  },
  {
    symbol: "SABERWRAPPEDBITCOIN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "SBTCB6pWqeDo6zGi9WVRMLCsKsN6JiR1RMUqvLtgSRv",
    sourceId: "979b9e2c59f75844cb13375b0d83b5b9:eth"
  },
  {
    symbol: "SABERWRAPPEDBITCOIN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "SBTCB6pWqeDo6zGi9WVRMLCsKsN6JiR1RMUqvLtgSRv",
    sourceId: "979b9e2c59f75844cb13375b0d83b5b9:solana"
  },
  {
    symbol: "SPAMTOKEN2",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "2znw8JBTW1w2HBNiRwsTpbunjZVZ3uiGdHUt9M72i2oN",
    sourceId: "f6a4f39362b88d64e9d1d289d0a6e9a5:eth"
  },
  {
    symbol: "SPAMTOKEN2",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "2znw8JBTW1w2HBNiRwsTpbunjZVZ3uiGdHUt9M72i2oN",
    sourceId: "f6a4f39362b88d64e9d1d289d0a6e9a5:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "5TPYH5sMvFMitzsjzM9xrxq5igpVuGugVu8CLzCrFdFW",
    sourceId: "bbb5abf6680674046a236e2a75302489:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "5TPYH5sMvFMitzsjzM9xrxq5igpVuGugVu8CLzCrFdFW",
    sourceId: "bbb5abf6680674046a236e2a75302489:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "95sn4kgeJnnBfRCD8S2quu4HS9Y6vb7JDuXrarnmEjYE",
    sourceId: "399c25b94ebe15d4baf4326a1fac5cf6:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "95sn4kgeJnnBfRCD8S2quu4HS9Y6vb7JDuXrarnmEjYE",
    sourceId: "399c25b94ebe15d4baf4326a1fac5cf6:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "XzR7CUMqhDBzbAm4aUNvwhVCxjWGn1KEvqTp3Y8fFCD",
    sourceId: "2555ae19affd642469f00e284cf94e23:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "XzR7CUMqhDBzbAm4aUNvwhVCxjWGn1KEvqTp3Y8fFCD",
    sourceId: "2555ae19affd642469f00e284cf94e23:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "2QSBLGnYgDQeNyJwUczAxcJ7JXgCz9GsBDqynsKxPdGw",
    sourceId: "3f678e8f979571f45b72155b24a9626a:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "2QSBLGnYgDQeNyJwUczAxcJ7JXgCz9GsBDqynsKxPdGw",
    sourceId: "3f678e8f979571f45b72155b24a9626a:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "3BjcHXvyzMsjmeqE2qFLx45K4XFx3JPiyRnjJiF5MAHt",
    sourceId: "57d7295fdd13bea45a0e2281a776b6c9:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "3BjcHXvyzMsjmeqE2qFLx45K4XFx3JPiyRnjJiF5MAHt",
    sourceId: "57d7295fdd13bea45a0e2281a776b6c9:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "EYwnq7q276WVZYpBwPapHGP5DxHJyRr77nGbTQAhLJSi",
    sourceId: "5ab9982acd64a114b9ec4d1a56167652:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "EYwnq7q276WVZYpBwPapHGP5DxHJyRr77nGbTQAhLJSi",
    sourceId: "5ab9982acd64a114b9ec4d1a56167652:solana"
  },
  {
    symbol: "ALEXANDRUHOCAZO-WHORTEZ",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "7a6r3s2fqkGNkLUVPuQyaSLH338XBqSVW1Ywck46q7to",
    sourceId: "e533156e48dc29544b6a72096f5bf9f0:eth"
  },
  {
    symbol: "ALEXANDRUHOCAZO-WHORTEZ",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "7a6r3s2fqkGNkLUVPuQyaSLH338XBqSVW1Ywck46q7to",
    sourceId: "e533156e48dc29544b6a72096f5bf9f0:solana"
  },
  {
    symbol: "BEARPAW",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "6AEhvXnuSadEw3228PSeoUgscnJJJd4gbhZXJhSLBT7k",
    sourceId: "08f03286dd3e7c44596c74062ba8b268:eth"
  },
  {
    symbol: "BEARPAW",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "6AEhvXnuSadEw3228PSeoUgscnJJJd4gbhZXJhSLBT7k",
    sourceId: "08f03286dd3e7c44596c74062ba8b268:solana"
  },
  {
    symbol: "CATSINADOGWORLD",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5",
    sourceId: "d676d063c20a6ac4191db6936f1031ca:eth"
  },
  {
    symbol: "CATSINADOGWORLD",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5",
    sourceId: "d676d063c20a6ac4191db6936f1031ca:solana"
  },
  {
    symbol: "FECES",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "5j2shkkzascw33QpW6RRqfRkacLkn7QwwV1e7jX36nyn",
    sourceId: "5076cefa14d63c345bdc23e71dd0ce92:eth"
  },
  {
    symbol: "FECES",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "5j2shkkzascw33QpW6RRqfRkacLkn7QwwV1e7jX36nyn",
    sourceId: "5076cefa14d63c345bdc23e71dd0ce92:solana"
  },
  {
    symbol: "HOLDIUM",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "3DH8WZ6C2HdDR4J9ekYnTfai8Tx8mxn92mW8zcYmP4px",
    sourceId: "eca3ed514d9a75b489b55bef38c42cd0:eth"
  },
  {
    symbol: "HOLDIUM",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "3DH8WZ6C2HdDR4J9ekYnTfai8Tx8mxn92mW8zcYmP4px",
    sourceId: "eca3ed514d9a75b489b55bef38c42cd0:solana"
  },
  {
    symbol: "IQ50",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "21rweMLGYeMNonHW7H3xa5py17X6ZFRcHirCp9inRBQA",
    sourceId: "3ce9a1fdc3f813c4caf0705faaf89371:eth"
  },
  {
    symbol: "IQ50",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "21rweMLGYeMNonHW7H3xa5py17X6ZFRcHirCp9inRBQA",
    sourceId: "3ce9a1fdc3f813c4caf0705faaf89371:solana"
  },
  {
    symbol: "IQ200",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "43ifqiWbixxQYFd7dtYuBhD6vPZMWLR8tfnsu8QcVkp5",
    sourceId: "c2e25b5ac142634469d55d67516ccad1:eth"
  },
  {
    symbol: "IQ200",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "43ifqiWbixxQYFd7dtYuBhD6vPZMWLR8tfnsu8QcVkp5",
    sourceId: "c2e25b5ac142634469d55d67516ccad1:solana"
  },
  {
    symbol: "MANEKI",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "25hAyBQfoDhfWx9ay6rarbgvWGwDdNqcHsXS3jQ3mTDJ",
    sourceId: "440bfc71c0aa1fc468a547d0526a4484:eth"
  },
  {
    symbol: "MANEKI",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "25hAyBQfoDhfWx9ay6rarbgvWGwDdNqcHsXS3jQ3mTDJ",
    sourceId: "440bfc71c0aa1fc468a547d0526a4484:solana"
  },
  {
    symbol: "PDT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "8ojLz4XJwvAG2HkoKiEH6zbBMALBeSrtZa6RrBZZonCZ",
    sourceId: "f77b1e117be397c44af9d98b0be1efce:eth"
  },
  {
    symbol: "PDT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "8ojLz4XJwvAG2HkoKiEH6zbBMALBeSrtZa6RrBZZonCZ",
    sourceId: "f77b1e117be397c44af9d98b0be1efce:solana"
  },
  {
    symbol: "SEALWIFHAT",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "Fxgdfsy1Z5Mvh53o69s2Ev6TGxtAJ1RQ5RJ5moCpKmQZ",
    sourceId: "adbfcbe1cd5cd6d4cb764267778cc19b:eth"
  },
  {
    symbol: "SEALWIFHAT",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "Fxgdfsy1Z5Mvh53o69s2Ev6TGxtAJ1RQ5RJ5moCpKmQZ",
    sourceId: "adbfcbe1cd5cd6d4cb764267778cc19b:solana"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "CP48bGTC7K4kuQ2Ct9PL93eXQ8BvJowuLqSTrkVxVedY",
    sourceId: "32505d751502caa4b88bacd206185b33:eth"
  },
  {
    symbol: "SPAMTOKEN",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "CP48bGTC7K4kuQ2Ct9PL93eXQ8BvJowuLqSTrkVxVedY",
    sourceId: "32505d751502caa4b88bacd206185b33:solana"
  },
  {
    symbol: "STEVEHULK",
    decimals: 18,
    chainKey: "evm:1",
    contractAddress: "DwNmcpEQmwvYo2fuwr2koTALWcigPgT4R8bMoDHAzdsf",
    sourceId: "cee804eec4970eb4b9274bab2a4a7d1f:eth"
  },
  {
    symbol: "STEVEHULK",
    decimals: 18,
    chainKey: "solana",
    contractAddress: "DwNmcpEQmwvYo2fuwr2koTALWcigPgT4R8bMoDHAzdsf",
    sourceId: "cee804eec4970eb4b9274bab2a4a7d1f:solana"
  }
]); 

export default TOOL88_SHIPPED_TOKEN_REGISTRY;
